import * as React from "react";
import { styled } from "@mui/system";
import MUIDialogContentText from "@mui/material/DialogContentText";
import { DialogContentTextProps } from "@mui/material/DialogContentText";

export const DialogContentText: (props: DialogContentTextProps) => JSX.Element =
  styled(
    React.forwardRef<HTMLSpanElement, DialogContentTextProps>((props, ref) => (
      <MUIDialogContentText ref={ref} {...props} />
    )),
    {
      name: "DialogContentText",
      slot: "Root",
      overridesResolver: (props, styles) => []
    }
  )(({ theme }) => ({
    "&.MuiDialogContentText-root": {
      ...theme.typography["body"]
    }
  }));
